import { Accounting } from '~/types/accounting';
import { AccountingIntegrationModel } from '../accounting-integration/AccountingIntegrationModel';
export function fromDTO(dto) {
    if (dto.source === Accounting.QBO) return AccountingIntegrationModel.fromQBO(dto);
    if (dto.source === Accounting.Xero) return AccountingIntegrationModel.fromXero(dto);
    return dto;
}
